export const LOGO_URL = "https://customer-assets.emergentagent.com/job_adac3932-fd12-4037-a0a4-41be098f4fe7/artifacts/9bm4nsp5_GA%206%20Logo.png";

export const CONTACT = {
  phone: "+919567339190",
  phoneDisplay: "+91 95673 39190",
  whatsapp: "919567339190",
  instagram: "https://www.instagram.com/carvings__architecture?igsh=MTFpcnlvajNubjQ1dw==",
  instagramHandle: "@carvings__architecture",
  email: "hello@ga6.in",
};

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "finishes", label: "Finishes" },
  { id: "applications", label: "Applications" },
  { id: "gallery", label: "Gallery" },
  { id: "training", label: "Training" },
  { id: "dealers", label: "Dealers" },
  { id: "journal", label: "Journal" },
  { id: "contact", label: "Contact" },
];

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1714924674541-9e11b2d1dd1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtaW5pbWFsJTIwY29uY3JldGUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMwODE1MDJ8MA&ixlib=rb-4.1.0&q=85",
];

export const IMG = {
  intro: "https://images.unsplash.com/photo-1717076521696-ea6d8ed0963a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtaW5pbWFsJTIwY29uY3JldGUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMwODE1MDJ8MA&ixlib=rb-4.1.0&q=85",
  texture1: "https://images.pexels.com/photos/16001335/pexels-photo-16001335.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  texture2: "https://images.pexels.com/photos/3964666/pexels-photo-3964666.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bath: "https://images.unsplash.com/photo-1642755623141-23b3cb4284aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxtaWNyb2NlbWVudCUyMGJhdGhyb29tfGVufDB8fHx8MTc4MzA4MTUwMnww&ixlib=rb-4.1.0&q=85",
  bath2: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtaWNyb2NlbWVudCUyMGJhdGhyb29tfGVufDB8fHx8MTc4MzA4MTUwMnww&ixlib=rb-4.1.0&q=85",
  arch1: "https://images.pexels.com/photos/34133564/pexels-photo-34133564.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  arch2: "https://images.pexels.com/photos/14528981/pexels-photo-14528981.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  training1: "https://images.unsplash.com/photo-1664638413509-6aa486866f9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxpbnRlcmlvciUyMGRlc2lnbmVyJTIwd29ya2luZ3xlbnwwfHx8fDE3ODMwODE1MDJ8MA&ixlib=rb-4.1.0&q=85",
  training2: "https://images.unsplash.com/photo-1664638413302-d1ca29ac885b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxpbnRlcmlvciUyMGRlc2lnbmVyJTIwd29ya2luZ3xlbnwwfHx8fDE3ODMwODE1MDJ8MA&ixlib=rb-4.1.0&q=85",
};

export const APPLICATION_IMAGES = {
  walls: IMG.arch1,
  floors: IMG.arch2,
  bathrooms: IMG.bath,
  kitchens: IMG.texture1,
  commercial: IMG.intro,
  facades: IMG.texture2,
};
